import React, {useState} from 'react'
import {InputPure, Row, Col, SearchIcon} from '@modifi/ui'
import {not, pickBy, startsWith} from 'ramda'
import qs from 'qs'
import {useTranslation} from '@modifi/plugin-i18n'

import {StyledButtonLink} from './styles'
import {useDebounce} from '../../hooks/useDebounce'

type LocationLike = {
  search: string
  [key: string]: any
}

type SearchFilterFormTypes = {
  onSubmit: (change: string) => null
  defaultParam: string
  location: {
    search: string
  }
  search: Record<string, unknown>
  replaceUrl: (location: LocationLike) => null
}

const SearchFilterForm: React.FC<SearchFilterFormTypes> = ({
  onSubmit,
  defaultParam,
  location,
  search,
  replaceUrl,
}) => {
  const {t} = useTranslation('kartavya')
  const initialValue =
    Array.isArray(defaultParam) && defaultParam?.length < 1 ? '' : defaultParam || ''
  const [value, setValue] = useState(initialValue)

  const handleResetClick = () => {
    setValue('')
    replaceUrl({
      ...location,
      search: qs.stringify({
        ...pickBy((val, key) => not(startsWith('search.', key)), search),
      }),
    })
  }

  const debouncedSubmit = useDebounce(onSubmit, 400)

  const handleOnChange = (evt: string, change: string) => {
    setValue(change)
    if (change && change?.length > 2) {
      debouncedSubmit(change)
    } else if (!change) {
      handleResetClick()
    }
  }

  return (
    <>
      <Row justifyContent="center" mt={8}>
        <Col>
          <InputPure
            autoFocus
            onChange={handleOnChange}
            isSmall
            value={value}
            icon={SearchIcon}
            placeholder={t('tasks.search-filter-form.search-input.placeholder')}
          />
        </Col>
      </Row>
      <Row mt={8} justifyContent="end">
        <Col col={3}>
          <StyledButtonLink
            transparent
            data-target="reset-search-filter-form"
            onClick={handleResetClick}
          >
            {t('tasks.filter.reset-search-filter-form.label')}
          </StyledButtonLink>
        </Col>
      </Row>
    </>
  )
}

export default SearchFilterForm
